"use strict";
import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import _ from "lodash";
import Dropzone from "react-dropzone";
import Button from "react-bootstrap-button-loader";
import { Modal, Tooltip, OverlayTrigger } from "react-bootstrap";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  openImportUserModal,
  importAppUsers,
  executeAppuserImportProcess,
  fetchBulkUplodedLeftUsers,
} from "DashboardUserAction";
import {
  NEW_IMAGE_PATH,
  validateEmail,
  checkDateFormatYMD,
  validateUrl,
  validateSocialMediaUrl,
} from "Constants";
import UserCell from "./user-cell";
import XLSX from "xlsx";
import Pagination from "react-js-pagination";
// import PaginationComponent from 'PaginationComponent';
import AppIcons from "AppIcons";
import LocaleStrings from "Languages";

const per_page_row = 10;

class ImportUsersDialog extends Component {
  constructor(props) {
    super(props);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);

    this.state = {
      accept:
        "text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      files: [],
      loading: false,
      processingData: false,
      hasData: false,
      importedusers: [],
      hasError: false,
      hasDataError: false,
      errorMessage: "",
      selectedPage: 1,
      paginatedData: {
        page: 0,
        per_page: 0,
        total: 0,
        total_pages: 0,
        data: [],
      },
      usersCount: 0,
      duplicateData: "update", // update -> update duplicate value / insert -> ship the duplicate value only insert the new data.
      actionUpdateSkipBlank: true, //  on update action skip the blank filed value
    };
    this.onDrop = this.onDrop.bind(this);
  }

  openModal() {
    this.retry();
    this.setState({ loading: false });
    this.props.openImportUserModal(true);
  }

  closeModal = () => {
    this.props.openImportUserModal(false);
    this.retry();
  };

  downloadSample = (type) => {
    let { settingData } = this.props;
    let XLSX = require("xlsx");
    let sample = [
      {
        Firstname: "Hazel1",
        Lastname: "Rose1",
        Email: "rose1.hazel@eventify.com",
        Userstatus: "confirmed",
        Category: "exhibitor",
        GDPR_Networking: "no",
        Photo: "https://hub.eventify.io/assets/appuser_profile.png",
      },
      {
        Firstname: "Hazel2",
        Lastname: "Rose2",
        Email: "rose2.hazel@eventify.com",
        Userstatus: "waitlist",
        Category: "attendee",
        GDPR_Networking: "yes",
        Photo: "https://hub.eventify.io/assets/appuser_profile.png",
      },
    ];

    var checkout =
      settingData &&
      settingData.event_forms_by_eventformid &&
      settingData.event_forms_by_eventformid.formjson
        ? JSON.parse(settingData.event_forms_by_eventformid.formjson)
        : [];

    _.map(sample, (item) => {
      _.map(checkout, (obj) => {
        if (
          obj.key === "textinput" ||
          obj.key === "textarea" ||
          obj.key === "numberinput"
        ) {
          item[`${obj.label} (Max length ${obj.maxlen})`] = "";
        } else if (
          obj.name != "termsconditions" &&
          obj.name != "isnetworking" &&
          obj.key != "hyperlink" &&
          obj.key != "label" &&
          obj.key != "paragraph" &&
          obj.key != "datepicker"
        ) {
          item[obj.label] = "";
        } else if (obj.key === "datepicker") {
          item[`${obj.label} (Use date field and format YYYY-MM-DD)`] = "";
        }
      });
    });

    /* Create a new empty workbook, then add the worksheet */
    let wb = XLSX.utils.book_new();

    /* Create a worksheet */
    var ws = XLSX.utils.json_to_sheet(sample);
    var sheetName = "sample";

    XLSX.utils.book_append_sheet(wb, ws, sheetName);

    /* Generate xlsx files */
    if (type === "csv") {
      XLSX.writeFile(wb, "sample.csv");
    } else {
      XLSX.writeFile(wb, "sample.xlsx");
    }
  };

  onDrop = (files) => {
    this.setState({
      files,
    });

    let file = files[0];
    var Papa = require("papaparse/papaparse.min.js");
    if (file && file.type === "text/csv") {
      Papa.parse(file, {
        skipEmptyLines: true,
        complete: function (results, file) {
          if (results.errors.length === 0) this.processCSV(results.data);
          else {
            this.setState({
              hasError: true,
              errorMessage: LocaleStrings.user_import_validation1,
            });
          }
        }.bind(this),
        error: function (error, reason) {
          this.setState({
            hasError: true,
            errorMessage: LocaleStrings.user_import_validation1,
          });
        },
      });
    } else {
      //debugger;
      const reader = new FileReader();
      const rABS = !!reader.readAsBinaryString;
      reader.onload = (e) => {
        /* Parse data */
        const bstr = e.target.result;
        const wb = XLSX.read(bstr, { type: rABS ? "binary" : "array" });
        /* Get first worksheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
        /* Update state */
        //this.setState({ data: data, cols: make_cols(ws['!ref']) });

        if (data.length === 0) {
          this.setState({
            hasError: true,
            errorMessage: LocaleStrings.user_import_validation1,
          });
        } else {
          this.processXLS(data);
        }
      };
      if (rABS) reader.readAsBinaryString(file);
      else reader.readAsArrayBuffer(file);
    }
  };

  processXLS = (result) => {
    this.processCSV(result);
  };

  processCSV = (result) => {
    let { session, settingData, userCategoryList } = this.props;
    var checkout =
      settingData &&
      settingData.event_forms_by_eventformid &&
      settingData.event_forms_by_eventformid.formjson
        ? JSON.parse(settingData.event_forms_by_eventformid.formjson)
        : [];
    var header = result[0];
    // console.log(result);

    this.setState({ processingData: true });
    if (header && header.length >= 7) {
      var firstnameheader = header[0].toString().trim();
      var lastnameheader = header[1].toString().trim();
      var emailheader = header[2].toString().trim();
      var userstatusheader = header[3].toString().trim();
      var categoryheader = header[4].toString().trim();
      var gdprheader = header[5].toString().trim();
      var photoheader = header[6].toString().trim();

      if (
        firstnameheader === "Firstname" &&
        lastnameheader === "Lastname" &&
        emailheader === "Email" &&
        userstatusheader === "Userstatus" &&
        categoryheader === "Category" &&
        gdprheader === "GDPR_Networking" &&
        photoheader === "Photo"
      ) {
        var newArray = _.drop(result, 1);
        var checkoutHeader = _.drop(header, 7);
        var modifiedArr = [];
        // console.log("checkoutHeader :- ", checkoutHeader);

        if (newArray.length > 0) {
          newArray.map((user, id) => {
            if (user.length > 1) {
              var firstname =
                user[0] && user[0] != "" ? user[0].toString().trim() : "";
              var lastname =
                user[1] && user[1] != "" ? user[1].toString().trim() : "";
              var name = firstname + " " + lastname;
              var email =
                user[2] && user[2] != "" ? user[2].toString().trim() : "";
              var userstatus =
                user[3] && user[3] != "" ? user[3].toString().trim() : "";
              var group =
                user[4] && user[4] != "" ? user[4].toString().trim() : "";
              var gdpr = user[5] && user[5] != "" ? user[5].toLowerCase() : "";
              var photo = user[6] && user[6] != "" ? user[6] : "";
              var checkoutValue = _.drop(user, 7);
              var checkoutForm = JSON.parse(JSON.stringify(checkout));
              var userNetworking = gdpr === "yes" ? 1 : 0;

              let checkboxvalue = [];
              _.map(checkoutForm, (obj, index) => {
                if (
                  obj.key === "textinput" ||
                  obj.key === "textarea" ||
                  obj.key === "numberinput"
                ) {
                  obj.value = "";
                  let check = checkoutHeader.indexOf(
                    `${obj.label} (Max length ${obj.maxlen})`
                  );

                  if (check >= 0 && checkoutValue[check]) {
                    obj.value = checkoutValue[check];
                  }
                } else if (obj.key === "datepicker") {
                  obj.value = "";
                  let check = checkoutHeader.indexOf(
                    `${obj.label} (Use date field and format YYYY-MM-DD)`
                  );

                  if (check >= 0 && checkoutValue[check]) {
                    if (checkDateFormatYMD(checkoutValue[check])) {
                      obj.value = checkoutValue[check]; // date as text format (YYYY-MM-DD)
                    } else if (
                      moment(checkoutValue[check]).isValid() &&
                      !isNaN(checkoutValue[check])
                    ) {
                      let converted_date = new Date(
                        Math.round((checkoutValue[check] - 25569) * 864e5)
                      );
                      converted_date = String(converted_date).slice(4, 15);
                      let date = converted_date.split(" ");

                      let day = date[1];

                      let month = date[0];
                      month =
                        "JanFebMarAprMayJunJulAugSepOctNovDec".indexOf(month) /
                          3 +
                        1;
                      if (month.toString().length <= 1) month = "0" + month;

                      let year = date[2];

                      if (!isNaN(day) && !isNaN(month) && !isNaN(day)) {
                        obj.value = `${year}-${month}-${day}`;
                      } else {
                        obj.value = checkoutValue[check];
                      }
                    } else {
                      obj.value = checkoutValue[check];
                    }
                  }
                } else if (
                  obj.key != "hyperlink" &&
                  obj.key != "label" &&
                  obj.key != "paragraph"
                ) {
                  if (obj.name == "isnetworking") {
                    obj.value = userNetworking;
                  } else if (obj.name == "termsconditions") {
                    obj.value = "1";
                  } else if (obj.key == "checkboxes") {
                    obj.value = [];
                    if (checkoutHeader.indexOf(`${obj.label}`) >= 0) {
                      let position = checkoutHeader.indexOf(`${obj.label}`);
                      let optionsdata = obj.options;

                      let checkboxesval = checkoutValue[position];

                      if (checkboxesval && checkboxesval != undefined) {
                        var checkboxesArr = checkboxesval.split(",");

                        let displayValue = [];
                        checkboxesArr.map((box) => {
                          let match = _.filter(optionsdata, (o) => {
                            return (
                              o.text.toLowerCase() == box.toLowerCase() ||
                              o.value.toLowerCase() == box.toLowerCase()
                            );
                          });

                          if (match.length > 0) {
                            displayValue.push(match[0].value);
                          }
                        });

                        obj.value = displayValue;
                      }

                      // checkboxvalue.push([checkoutValue[checkoutHeader.indexOf(`${obj.label}`)]]);
                      // obj.value =checkboxvalue;
                    }
                  } else if (
                    obj.key == "radiobuttons" ||
                    obj.key == "dropdown"
                  ) {
                    obj.value = "";
                    if (checkoutHeader.indexOf(`${obj.label}`) >= 0) {
                      let position = checkoutHeader.indexOf(`${obj.label}`);
                      let optionsdata = obj.options;

                      let checkval = checkoutValue[position];

                      if (checkval && checkval != undefined) {
                        let match = _.filter(optionsdata, (o) => {
                          return (
                            o.text.toLowerCase() == checkval.toLowerCase() ||
                            o.value.toLowerCase() == checkval.toLowerCase()
                          );
                        });

                        if (match.length > 0) {
                          obj.value = match[0]["value"];
                        }
                      }
                    }
                  } else {
                    obj.value = "";
                    let check = checkoutHeader.indexOf(`${obj.label}`);

                    if (check >= 0 && checkoutValue[check]) {
                      obj.value = checkoutValue[check];
                    }
                  }
                }
              });

              modifiedArr.push({
                name: name,
                firstname: firstname,
                lastname: lastname,
                email: email,
                userstatus: userstatus,
                category: group,
                isnetworking: gdpr,
                profileurl: photo,
                responses: JSON.stringify(checkoutForm),
                action: this.state.duplicateData,
                eventid: session.eventid,
                hasErrors: [],
                rowno: id + 2,
              });
            }
          });
          // console.log("modifiedArr :- ", modifiedArr);

          // check only email as unique
          var hasduplicates =
            _.uniqBy(modifiedArr, "email").length !== modifiedArr.length;
          var groupped = _.groupBy(modifiedArr, function (n) {
            return n.email;
          }); // Grouping array by eamils
          var duplicatesArr = _.uniq(
            _.flatten(
              _.filter(groupped, function (n) {
                return n.length > 1;
              })
            )
          ); // Getting the duplicates values from groupped array whose length is > 1
          var uniqueDuplicateEmailsData = _.uniqBy(duplicatesArr, "email"); // Getting unique array from duplicates array
          let duplcateEmails = uniqueDuplicateEmailsData.map((a) => a.email); // Getting the duplicates emails

          var ErrorDataArr = [];
          modifiedArr.map((obj, id) => {
            var user = JSON.parse(JSON.stringify(obj));
            var errors = [];

            if (user.firstname == "") {
              errors.push(
                LocaleStrings.user_table_list_first_name +
                  " " +
                  LocaleStrings.small_required
              );
            }
            if (user.lastname == "") {
              errors.push(
                LocaleStrings.user_table_list_last_name +
                  " " +
                  LocaleStrings.small_required
              );
            }
            if (user.email == "") {
              errors.push(
                LocaleStrings.user_table_list_email +
                  " " +
                  LocaleStrings.small_required
              );
            } else if (user.email && !validateEmail(user.email)) {
              errors.push(LocaleStrings.user_validation_invalid_email);
            } else if (
              user.email &&
              user.email === session.emailid &&
              user.category != ""
            ) {
              var categories = user.category.toLowerCase().split(",");

              // get admin group
              var matchCat = _.filter(userCategoryList.data, (o) => {
                return o.type === "admin";
              });
              let adminCatName = matchCat[0].groupname.toLowerCase();

              let checkAmdin = categories.includes(adminCatName);
              if (checkAmdin === false) {
                errors.push(LocaleStrings.user_import_validation9);
              }
            }

            if (duplcateEmails.indexOf(user.email.trim()) >= 0) {
              errors.push(LocaleStrings.user_import_validation3);
            }

            if (user.profileurl && !validateUrl(user.profileurl)) {
              errors.push(LocaleStrings.user_import_validation7);
            }

            // Checking user status as per our record.
            if (
              user.userstatus &&
              user.userstatus.toLowerCase() != "confirmed" &&
              user.userstatus.toLowerCase() != "waitlist" &&
              user.userstatus.toLowerCase() != "inactive"
            ) {
              errors.push(LocaleStrings.user_import_validation10);
            }

            // Checking categories as per our record.
            if (user.category != "") {
              var categoriesNotAvail = [];
              var categories = user.category.split(",");

              _.map(categories, (obj) => {
                var matchCat = _.filter(userCategoryList.data, (o) => {
                  return o.groupname.toLowerCase() == obj.toLowerCase();
                });
                if (matchCat.length < 1) {
                  categoriesNotAvail.push(obj);
                }
              });

              if (categoriesNotAvail.length > 0) {
                errors.push(
                  `${categoriesNotAvail.join(" & ")} ${
                    LocaleStrings.user_import_validation8
                  }`
                );
              }
            }
            // else {
            //   errors.push(
            //     LocaleStrings.user_table_list_category +
            //       " " +
            //       LocaleStrings.small_required
            //   );
            // }

            var responses = JSON.parse(user.responses);
            _.map(responses, (obj) => {
              if (
                obj.key === "textinput" ||
                obj.key === "textarea" ||
                obj.key === "numberinput"
              ) {
                if (obj.value && obj.maxlen && obj.value.length > obj.maxlen) {
                  errors.push(`${obj.label} length should be < ${obj.maxlen}`);
                }

                if (obj.key === "numberinput" && isNaN(obj.value)) {
                  errors.push(`${obj.label} ${LocaleStrings.invalid_number}`);
                }

                if (
                  (obj.name === "facebook" ||
                    obj.name === "linkedin" ||
                    obj.name === "twitter") &&
                  obj.value &&
                  obj.value !== "" &&
                  !validateSocialMediaUrl(obj.value)
                ) {
                  errors.push(`${obj.label} ${LocaleStrings.invalid_url}`);
                }
              } else if (
                obj.key === "datepicker" &&
                obj.value &&
                obj.value != "" &&
                !checkDateFormatYMD(obj.value)
              ) {
                errors.push(
                  `${obj.label} ${LocaleStrings.invalid_date_format}`
                );
              }
            });

            if (errors.length > 0) {
              // storing errors
              user.hasErrors = errors;
              ErrorDataArr.push(user);
            }
          });

          var pageNumber = 1;
          var dataArray = ErrorDataArr.length > 0 ? ErrorDataArr : modifiedArr;
          var paginatedData = this.getPaginatedItems(dataArray, pageNumber);
          this.setState({
            hasData: true,
            hasDataError: ErrorDataArr.length > 0,
            importedusers: ErrorDataArr.length > 0 ? ErrorDataArr : dataArray,
            selectedPage: pageNumber,
            paginatedData,
            usersCount:
              ErrorDataArr.length > 0 ? ErrorDataArr.length : dataArray.length,
          });
        } else {
          this.setState({
            hasError: true,
            errorMessage: LocaleStrings.user_import_validation6,
          });
        }
      } else {
        this.setState({
          hasError: true,
          errorMessage: LocaleStrings.user_import_validation4,
        });
      }
    } else {
      this.setState({
        hasError: true,
        errorMessage: LocaleStrings.user_import_validation4,
      });
    }
  };

  onOptionChange = (e) => {
    let clickedValue = e.target.value;
    var updatedRecord = [];

    this.state.importedusers.map((user, id) => {
      user.action = clickedValue;
      updatedRecord.push(user);
    });

    let action = clickedValue === "update" ? true : false;

    this.setState({
      duplicateData: clickedValue,
      actionUpdateSkipBlank: action,
      // importedusers: updatedRecord,
    });
  };

  onUpdateTypeChange = (e) => {
    let val = e.target.checked;

    this.setState({
      actionUpdateSkipBlank: val,
    });
  };

  importUser = () => {
    let { duplicateData, actionUpdateSkipBlank, importedusers } = this.state;

    // console.log(duplicateData, actionUpdateSkipBlank, importedusers);

    let action = "update";
    if (duplicateData === "insert") {
      action = "insert";
    } else {
      if (actionUpdateSkipBlank === true) {
        action = "update_skip_blank";
      }
    }

    let importData = [];
    importedusers.map((user, id) => {
      user.action = action;
      importData.push(user);
    });

    // console.log("importData :- ", importData);

    this.setState({ loading: true });
    this.props.executeAppuserImportProcess(
      this.props.session,
      importData,
      (response) => {
        if (response.success === 0) {
          this.setState({ loading: false });
          this.props.showError(LocaleStrings.user_import_validation5);
        } else if (response.success === 2) {
          this.setState({ loading: false });
          this.props.showError(LocaleStrings.user_import_validation4);
        } else {
          this.props.refreshPage();
          setTimeout(() => {
            this.setState({ loading: false });
            this.props.showSuccess(LocaleStrings.user_message_user_imported);
            this.closeModal();
          }, 1000);
        }
      }
    );

    // this.props.importAppUsers(this.props.session, importData, (response) => {
    //   if (response.success === 0) {
    //     this.setState({ loading: false });
    //     this.props.showError(LocaleStrings.user_import_validation5);
    //   } else {
    //     this.setState({ loading: false });
    //     this.closeModal();
    //     this.props.showSuccess(LocaleStrings.user_message_user_imported);
    //     this.props.executeAppuserImportProcess(this.props.session, (res) => {
    //       this.props.callbackUploadUser();

    //       // setTimeout(() => {
    //       //   this.setState({ loading: false });
    //       //   this.props.showSuccess(LocaleStrings.user_message_user_imported);
    //       //   this.closeModal();
    //       // }, 5000);
    //     });
    //   }
    // });
  };

  retry = () => {
    this.setState({
      processingData: false,
      hasData: false,
      hasError: false,
      hasDataError: false,
      errorMessage: "",
    });
  };

  getPaginatedItems = (items, page) => {
    var page = page || 1,
      per_page = 10,
      offset = (page - 1) * per_page,
      paginatedItems = _.drop(items, offset).slice(0, per_page);
    return {
      page: page,
      per_page: per_page,
      total: items.length,
      total_pages: Math.ceil(items.length / per_page),
      data: paginatedItems,
    };
  };

  refreshLeftUser = () => {
    this.props.fetchBulkUplodedLeftUsers(this.props.session);
    // this.props.executeAppuserImportProcess(this.props.session); // Call the import appuser from temp table to appser, if in any case its fail to call from appuser_temp.post.post_script. (Nor required now as we are calling the direct api to import)
    this.props.refreshPage();
  };

  paginationCallback = (pageNumber) => {
    if (this.state.selectedPage !== pageNumber) {
      var paginatedData = this.getPaginatedItems(
        this.state.importedusers,
        pageNumber
      );
      this.setState({ selectedPage: pageNumber, paginatedData });
    }
  };

  renderCheckoutHeader = () => {
    let { settingData } = this.props;

    var checkout =
      settingData &&
      settingData.event_forms_by_eventformid &&
      settingData.event_forms_by_eventformid.formjson
        ? JSON.parse(settingData.event_forms_by_eventformid.formjson)
        : [];

    return _.map(checkout, (obj) => {
      if (
        obj.key === "textinput" ||
        obj.key === "textarea" ||
        obj.key === "numberinput"
      ) {
        return (
          <th key={`key_th_${obj.name}`}>
            <span>{`${obj.label} (Max length ${obj.maxlen})`}</span>
          </th>
        );
      } else if (
        obj.name != "termsconditions" &&
        obj.name != "isnetworking" &&
        obj.key != "hyperlink" &&
        obj.key != "label" &&
        obj.key != "paragraph" &&
        obj.key != "datepicker"
      ) {
        return (
          <th key={`key_th_${obj.name}`}>
            <span>{`${obj.label}`}</span>
          </th>
        );
      } else if (obj.key === "datepicker") {
        return (
          <th key={`key_th_${obj.name}`}>
            <span>{`${obj.label} (Use date field and format YYYY-MM-DD)`}</span>
          </th>
        );
      }
    });
  };

  renderUserList = () => {
    let { paginatedData } = this.state;

    return _.map(paginatedData.data, (user, id) => {
      return <UserCell key={id} user={user} session={this.props.session} />;
    });
  };

  render() {
    var { bulkUplodingLeft } = this.props;

    var {
      accept,
      processingData,
      hasData,
      hasError,
      hasDataError,
      errorMessage,
      usersCount,
      paginatedData,
      duplicateData,
    } = this.state;
    var count_user = usersCount > 0 ? usersCount : "";
    var pageCount = paginatedData.total_pages;
    var defaultModalClass = hasData ? "user-import-withdata-modal" : "modal-lg";
    let acceptObj = { accept: accept };

    return (
      <>
        {bulkUplodingLeft.count > 0 ? (
          <div className="vertical-align-center gap-1">
            <Button
              type="button"
              className="btn-custom-blue"
              disabled
              loading={true}
            >
              <span>
                {bulkUplodingLeft.count} {LocaleStrings.user_users_left}
              </span>
            </Button>
            <OverlayTrigger
              key="refresh"
              placement="right"
              overlay={
                <Tooltip id="tooltip-manage" className="hide">
                  {LocaleStrings.user_refresh_dashboard}
                </Tooltip>
              }
            >
              <Button
                type="button"
                className="btn-custom-white"
                onClick={this.refreshLeftUser}
                title={LocaleStrings.user_refresh_dashboard}
              >
                <i className="fa fa-refresh" aria-hidden="true"></i>
              </Button>
            </OverlayTrigger>
          </div>
        ) : (
          <Button
            type="button"
            className="btn-custom-blue schedule-add-button vertical-align-center"
            onClick={this.openModal}
          >
            <span className="font-icomoon i-custom-ms">
              {AppIcons.uploadericon}
            </span>
            &nbsp;
            {LocaleStrings.button_csv_xml_import}
          </Button>
        )}

        <div>
          <Modal
            className="modal-container"
            show={this.props.showModal === true ? true : false}
            onHide={this.closeModal}
            animation={true}
            dialogClassName={defaultModalClass}
            size={"xl"}
            backdrop="static"
          >
            <Modal.Header>
              <div className="import-modal-title">
                {LocaleStrings.user_import_header}
              </div>
              <button
                type="button"
                className="i-custom-cross-popup pull-right"
                onClick={() => this.closeModal()}
              >
                <img
                  className="i-custom-small"
                  src="../../style/images/custom-icons/cross-black.png"
                />
              </button>
            </Modal.Header>
            <Modal.Body>
              {processingData ? (
                hasData ? (
                  <div className="imported-users">
                    {hasDataError ? (
                      <div className="custom-text1-primary-medium">
                        {LocaleStrings.user_import_error_rows_message}. Please
                        fix this row to add all users.
                      </div>
                    ) : (
                      ""
                    )}
                    <table className="table new-table">
                      <thead>
                        <tr style={{ display: "flex" }}>
                          <th>{LocaleStrings.user_table_list_rowno}</th>
                          <th>{LocaleStrings.user_table_list_first_name}</th>
                          <th>{LocaleStrings.user_table_list_last_name}</th>
                          <th>{LocaleStrings.user_table_list_email}</th>
                          <th>{LocaleStrings.user_table_list_userstatus}</th>
                          <th>{LocaleStrings.user_table_list_category}</th>
                          <th>{LocaleStrings.user_table_list_gdpr}</th>
                          <th>{LocaleStrings.user_table_list_photo}</th>
                          {this.renderCheckoutHeader()}
                        </tr>
                      </thead>

                      <tbody>{this.renderUserList()}</tbody>
                    </table>
                  </div>
                ) : hasError ? (
                  <div className="import-error">
                    <div>{errorMessage}</div>
                    <div>
                      <button
                        type="button"
                        className="btn btn-danger text-uppercase user-add-btn"
                        onClick={this.retry}
                      >
                        <i className="fa fa-arrow-rotate-right pull-left import-retry"></i>{" "}
                        {LocaleStrings.button_retry}
                      </button>
                    </div>
                  </div>
                ) : (
                  <div>{LocaleStrings.user_message_processing_data}..</div>
                )
              ) : (
                <div className="form-group formdiv">
                  <div className="row">
                    <div
                      className="col-sm-6 col-sm-offset-0 imgPreview"
                      style={{ padding: "0px", marginLeft: -10 }}
                    >
                      <section>
                        <div className="dropzone">
                          <Dropzone onDrop={this.onDrop} multiple={false}>
                            {({ getRootProps, getInputProps }) => (
                              <div
                                className="importdropbox"
                                {...getRootProps()}
                              >
                                <input {...getInputProps()} />
                                <div className="import-drop-text">
                                  <div>
                                    <img src={`${NEW_IMAGE_PATH}upload.png`} />
                                  </div>
                                  <div>
                                    {
                                      LocaleStrings.user_import_text_click_drag_drop_1
                                    }{" "}
                                    <br />
                                    {
                                      LocaleStrings.user_import_text_click_drag_drop_2
                                    }
                                  </div>
                                </div>
                              </div>
                            )}
                          </Dropzone>
                        </div>
                      </section>
                    </div>
                    <div className="col-sm-6 col-sm-offset-0">
                      <div className="import-title">
                        {LocaleStrings.user_import_download_template}
                      </div>
                      <div className="import-subtitle">
                        {LocaleStrings.user_import_download_template_subtitle1}
                      </div>
                      <div style={{ marginTop: 10 }}>
                        <div className="import-option">
                          <a
                            className="users-link"
                            onClick={() => this.downloadSample("csv")}
                          >
                            <img src={`${NEW_IMAGE_PATH}download.png`} />{" "}
                            <span className="import-option-button">
                              {LocaleStrings.user_import_sample_csv}
                            </span>
                          </a>
                        </div>
                        <div className="import-option">
                          <a
                            className="users-link"
                            onClick={() => this.downloadSample("xlsx")}
                          >
                            <img src={`${NEW_IMAGE_PATH}download.png`} />{" "}
                            <span className="import-option-button">
                              {LocaleStrings.user_import_sample_xls}
                            </span>
                          </a>
                        </div>
                        <div className="import-option">
                          <img
                            className="xls-sample-img"
                            src={`${NEW_IMAGE_PATH}xls_template.png`}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12 col-sm-12 import-notes">
                      <ul>
                        <li className="import-notes-title">
                          {LocaleStrings.notes}
                        </li>
                        <li>- {LocaleStrings.column_header_format}</li>
                        <li>- {LocaleStrings.duplicate_user_entries}</li>
                        <li>- {LocaleStrings.three_mandatory_fields}</li>
                        <li>- {LocaleStrings.phone_format}</li>
                        <li>- {LocaleStrings.email_format}</li>
                        <li>- {LocaleStrings.date_format}</li>
                        <li>- {LocaleStrings.user_import_note1}</li>
                        <li>- {LocaleStrings.user_import_note2}</li>
                        <li>- {LocaleStrings.user_import_note3}</li>
                        <li>- {LocaleStrings.user_import_note4}</li>
                        <li>- {LocaleStrings.user_import_note5}</li>
                        <li>- {LocaleStrings.user_import_note6}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              )}
              {!hasError && hasData && pageCount > 1 ? (
                // <div className="pull-right">
                //   <ul className="pagination">
                //     {this.renderPaginationList()}
                //   </ul>
                // </div>
                <div style={{ marginTop: "16px" }}>
                  <Pagination
                    activePage={this.state.selectedPage}
                    itemsCountPerPage={per_page_row}
                    totalItemsCount={this.state.importedusers.length}
                    pageRangeDisplayed={10}
                    onChange={this.paginationCallback}
                    className="importuser-pagination"
                  />
                </div>
              ) : null}
            </Modal.Body>
            {hasData && usersCount > 0 && !hasDataError ? (
              <Modal.Footer>
                <div className="d-flex gap-5">
                  <div className="d-flex gap-3">
                    <div>
                      <div>
                        <b className="me-3">
                          {
                            LocaleStrings.user_import_text_action_on_uploaded_data
                          }
                        </b>
                        <span>
                          <input
                            type="radio"
                            value="update"
                            name="actionwithdata"
                            checked={
                              this.state.duplicateData == "update"
                                ? true
                                : false
                            }
                            onChange={this.onOptionChange.bind(this)}
                          />{" "}
                          {
                            LocaleStrings.user_import_text_action_on_uploaded_data_option1
                          }
                        </span>
                      </div>
                      {duplicateData === "update" ? (
                        <div className="text-right">
                          {
                            LocaleStrings.user_import_text_action_on_uploaded_data_option1_skip
                          }{" "}
                          <input
                            type="checkbox"
                            name="action-update-child"
                            checked={
                              this.state.actionUpdateSkipBlank ? true : false
                            }
                            onChange={this.onUpdateTypeChange.bind(this)}
                          />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>

                    <span>
                      <input
                        type="radio"
                        value="insert"
                        name="actionwithdata"
                        checked={
                          this.state.duplicateData == "insert" ? true : false
                        }
                        onChange={this.onOptionChange.bind(this)}
                      />{" "}
                      {
                        LocaleStrings.user_import_text_action_on_uploaded_data_option2
                      }
                    </span>
                  </div>
                  <div>
                    <Button
                      style={{ width: 225 }}
                      className="btn-custom-blue"
                      loading={this.state.loading}
                      type="button"
                      onClick={this.importUser.bind(this)}
                    >
                      {LocaleStrings.import} {count_user} {LocaleStrings.users}
                    </Button>
                  </div>
                </div>
              </Modal.Footer>
            ) : (
              <Modal.Footer>
                {hasDataError ? (
                  <Button
                    variant="danger"
                    className="btn-custom-delete"
                    onClick={this.retry}
                  >
                    {LocaleStrings.button_retry}
                  </Button>
                ) : (
                  ""
                )}
                <Button className="btn-custom-white" onClick={this.closeModal}>
                  {LocaleStrings.button_close}
                </Button>
              </Modal.Footer>
            )}
          </Modal>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  var eventsetting = [];
  if (
    state.SettingData &&
    state.SettingData.resource &&
    state.SettingData.resource.length > 0
  ) {
    eventsetting = state.SettingData.resource[0];
  }

  return {
    session: state.session,
    showModal: state.showImportUserModal,
    bulkUplodingLeft: state.bulkUserUplodingLeft,
    settingData: eventsetting,
    userCategoryList: state.userCategoryList,
  };
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  openImportUserModal,
  importAppUsers,
  executeAppuserImportProcess,
  fetchBulkUplodedLeftUsers,
})(ImportUsersDialog);
